<template>
  <campsite-subsection
    v-show="campsite.point"
    id="local-attractions"
    name="local-attractions"
    :open="$isDesktop"
  >
    <template #title>
      <translate>Local attractions</translate>
    </template>
    <template #contents>
      <campsite-local-attractions
        :campsite-hierarchy-country="
          campsite.hierarchy && campsite.hierarchy.country
        "
        :nearby-activities="campsite.nearbyActivities"
        :needs-translation="campsite.nearbyActivitiesNeedsTranslation"
        :point="campsite.point"
        class="local-attractions-subsection"
        :class="{
          'with-festivals': campsite.attractions.nearbyFestivals.length,
        }"
      >
        <template #activities-list>
          <campsite-activities-list
            :points="campsite.attractions.activities || []"
          />
        </template>
        <template #water-quality>
          <campsite-water-quality
            v-if="shouldShowWaterQuality"
            :points="campsite.attractions.waterQuality || []"
          />
        </template>
        <template #visit-britain>
          <campsite-visit-britain
            :points="campsite.attractions.visitBritain || []"
          />
        </template>
        <template #national-trust>
          <campsite-national-trust
            :points="campsite.attractions.nationalTrust || []"
          />
        </template>
        <template #festivals>
          <campsite-festivals
            v-if="campsite.attractions.nearbyFestivals"
            :points="campsite.attractions.nearbyFestivals"
          />
        </template>
      </campsite-local-attractions>
    </template>
  </campsite-subsection>
</template>

<script lang="ts">
import type { CampsiteDetails } from '../../../campsite-details/types'
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'

@Component
class CampsiteLocalAttractionsSubsection extends Vue {
  @Prop()
  campsite: CampsiteDetails

  get shouldShowWaterQuality() {
    const waterQuality = this.campsite.attractions.waterQuality
    return waterQuality && waterQuality.length
  }
}

export default toNative(CampsiteLocalAttractionsSubsection)
</script>
